module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_sweet_vanilla-674a08ca.png";